import Modal from "components/modal"
import MainFormContext from "context/main-form"
import { FC, useCallback, useState } from "react"
import IMainForm from "rules/interface/context/main-form-context.interface"
import MainForm from "./form"
import styles from "./index.module.scss"




interface IProps {
    opened: boolean
    onClose: () => void
    formType?: string
}

const ModelsForm: FC<IProps> = ({ opened, onClose, formType }) => {

    const [values, setValues] = useState<IMainForm>({
        _id: null,
        step: 0,
        nextStep: (number?: number): void => nextStep(number ?? 1),
        prevStep: (): void => prevStep(),
        withinGoal: true,
        ...(formType && {
            formType: formType
        })
    })


    const nextStep = useCallback((number?: number): void => {
        setValues(prev => ({
            ...prev,
            preStep: [...prev.preStep ?? [], prev.step],
            step: prev.step + (number ?? 1)
        }))
    }, [values.step])

    const prevStep = useCallback((): void => {
        setValues(prev => ({
            ...prev,
            preStep: (prev.preStep?.slice(0, -1)),
            step: (prev.preStep?.slice(-1)?.[0]) ?? (prev.step - 1) ?? 0,
        }))
    }, [values.step])





    return (
        <Modal
            className={styles.modal}
            visible={opened}
            onClose={onClose}
            closeable
        >
            <MainFormContext.Provider value={{ values, setValues }}>
                <MainForm />
            </MainFormContext.Provider>
        </Modal>
    )
}

export default ModelsForm
